(function(){
  var root=document.documentElement;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $=function(s,c){return (c||document).querySelector(s)};
  var $$=function(s,c){return [].slice.call((c||document).querySelectorAll(s))};

  // ---- flip cards: every .flip is a real button with aria-pressed ----
  $$('.flip').forEach(function(b){
    b.addEventListener('click',function(){b.setAttribute('aria-pressed',b.getAttribute('aria-pressed')==='true'?'false':'true')});
  });

  // ---- smooth anchor scroll ----
  $$('.yn a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var id=a.getAttribute('href'); if(id.length<2)return;
      var t=$(id); if(!t)return; e.preventDefault();
      t.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
      history.replaceState(null,'',id);
    });
  });

  // ---- reveal on scroll, with failsafes: nothing may stay hidden if IO never fires ----
  var targets=$$('[data-reveal]').concat($$('#deck,#steps,#unbox'));
  function show(t){t.classList.add(t.id==='unbox'?'open':'in')}
  if(reduce||!('IntersectionObserver' in window)){targets.forEach(show)}
  else{
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){show(en.target);io.unobserve(en.target)}})},
      {rootMargin:'0px 0px -12% 0px',threshold:.12});
    targets.forEach(function(t){io.observe(t)});
    setTimeout(function(){targets.forEach(function(t){var r=t.getBoundingClientRect();if(r.top<innerHeight&&r.bottom>0)show(t)})},1200);
    setTimeout(function(){targets.forEach(show)},6000);
  }

  // ---- hero stage: gentle pointer tilt on desktop ----
  var stage=$('#stage');
  if(stage&&fine&&!reduce){
    var hero=$('.hero');
    hero.addEventListener('pointermove',function(e){
      var r=stage.getBoundingClientRect();
      stage.style.setProperty('--tx',((e.clientX-(r.left+r.width/2))/r.width).toFixed(3));
      stage.style.setProperty('--ty',((e.clientY-(r.top+r.height/2))/r.height).toFixed(3));
    });
    hero.addEventListener('pointerleave',function(){stage.style.setProperty('--tx',0);stage.style.setProperty('--ty',0)});
  }

  // ---- scroll-linked depth on the gift boxes ----
  var stack=$('#stack3');
  if(stack&&!reduce){
    var ticking=false;
    function depth(){
      ticking=false; var r=stack.getBoundingClientRect(); if(r.bottom<0||r.top>innerHeight)return;
      var p=(r.top+r.height/2-innerHeight/2)/innerHeight; // -0.5..0.5 around viewport centre
      stack.style.setProperty('--p1',(p*-28).toFixed(1)+'px');
      stack.style.setProperty('--p2',(p*-58).toFixed(1)+'px');
      stack.style.setProperty('--p3',(p*-16).toFixed(1)+'px');
    }
    addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(depth)}},{passive:true});
    depth();
  }

  // ---- situations rail: arrows scroll one tile (RTL: "next" moves left) ----
  var rail=$('#rail');
  $$('[data-rail]').forEach(function(b){
    b.addEventListener('click',function(){
      var tile=rail.firstElementChild; var step=tile?tile.getBoundingClientRect().width+16:300;
      rail.scrollBy({left:-step*Number(b.getAttribute('data-rail')),behavior:reduce?'auto':'smooth'});
    });
  });

  // ---- pricing ladder: selection drives summary, WhatsApp link and the mobile bar ----
  var sum=$('#sum'),wa=$('#waBtn'),bb=$('#bbTxt');
  $$('#tiers input').forEach(function(inp){
    inp.addEventListener('change',function(){
      var w=inp.getAttribute('data-word'),t=inp.getAttribute('data-total');
      sum.innerHTML='נבחר: '+w+' <b>'+t+' ₪</b>';
      bb.innerHTML=w+'<b>'+t+' ₪</b>';
      wa&&wa.setAttribute('href',inp.getAttribute('data-wa'));
    });
  });

  // ---- mobile buy bar: after the hero, hidden while the order section is on screen ----
  var bar=$('#buybar'),heroEl=$('.hero'),buy=$('#kniya');
  if(bar){
    var sync=function(){
      var past=(scrollY||root.scrollTop)>(heroEl?heroEl.offsetTop+heroEl.offsetHeight*0.8:500);
      var r=buy.getBoundingClientRect(); var atBuy=r.top<innerHeight&&r.bottom>0;
      var on=past&&!atBuy; bar.classList.toggle('show',on); bar.setAttribute('aria-hidden',on?'false':'true');
      bar.querySelector('a').tabIndex=on?0:-1;
    };
    sync(); addEventListener('scroll',sync,{passive:true}); addEventListener('resize',sync,{passive:true});
  }
})();

/* ---- Shopify port: cart page quantities, tier amount ---- */
(function(){
  [].forEach.call(document.querySelectorAll('.qty'),function(q){
    var inp=q.querySelector('input');
    [].forEach.call(q.querySelectorAll('button'),function(b){b.addEventListener('click',function(){
      inp.value=Math.max(0,(parseInt(inp.value,10)||0)+Number(b.getAttribute('data-step')));
      var f=document.getElementById('cartForm');if(f){var h=document.createElement('input');h.type='hidden';h.name='update';h.value='1';f.appendChild(h);f.submit()}
    })});
  });
  [].forEach.call(document.querySelectorAll('#tiers input'),function(inp){inp.addEventListener('change',function(){
    var a=document.getElementById('buyAmt');if(a)a.textContent=inp.getAttribute('data-total')+' ₪'})});
})();

/* Cart drawer: moved to assets/yansh-cart.js + snippets/yansh-cart-drawer.liquid (2026-10-07), shared by every layout. */
